var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3a2410",
    strokeWidth: 2.4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 30,
    height: 24,
    rx: 1.5,
    fill: "#c08a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15 H35 M5 27 H35",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9 L35 33 M35 9 L5 33",
    fill: "none",
    strokeWidth: 1.6,
    opacity: 0.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrate);
export default __webpack_public_path__ + "static/media/crate.15958965ccacb54531894de56109adf9.svg";
export { ForwardRef as ReactComponent };